export const defaults = {
  speed: 1,               // relative speed (higher = faster)
  direction: 'left',      // left | right
  gap: 48,                // px between original and clone
  pauseOnHover: 'true',
};

export default async function marquee(el, options) {
  const speed        = parseFloat(options.speed);
  const gap          = parseFloat(options.gap);
  const reversed     = options.direction === 'right';
  const pauseOnHover = options.pauseOnHover !== 'false';

  // Expected DOM: el wraps a single track element that contains the items
  const track = el.firstElementChild;
  if (!track) return;

  Object.assign(el.style, {
    overflow: 'hidden',
    display: 'flex',
  });

  Object.assign(track.style, {
    display: 'flex',
    alignItems: 'center',
    gap: `${gap}px`,
    flexShrink: '0',
    willChange: 'transform',
  });

  // Clone for seamless loop
  const clone = track.cloneNode(true);
  Object.assign(clone.style, {
    display: 'flex',
    alignItems: 'center',
    gap: `${gap}px`,
    flexShrink: '0',
    marginLeft: `${gap}px`,
    willChange: 'transform',
  });
  el.appendChild(clone);

  const trackWidth = track.scrollWidth + gap;
  const duration   = (trackWidth / (speed * 80)) * 1000; // ms

  const keyframes = reversed
    ? [{ transform: `translateX(-${trackWidth}px)` }, { transform: 'translateX(0)' }]
    : [{ transform: 'translateX(0)' }, { transform: `translateX(-${trackWidth}px)` }];

  const anim = el.animate(keyframes, {
    duration,
    iterations: Infinity,
    easing: 'linear',
  });

  if (pauseOnHover) {
    el.addEventListener('mouseenter', () => anim.pause());
    el.addEventListener('mouseleave', () => anim.play());
  }
}
